import { render, staticRenderFns } from "./SuggestionBanner.vue?vue&type=template&id=ee3403ca&"
import script from "./SuggestionBanner.vue?vue&type=script&lang=js&"
export * from "./SuggestionBanner.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionBanner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports